import styled from "styled-components";

export const WeekText = styled.div`
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  font-weight: 600;
  color: #333333;
  text-align: center;
`;